<template>
    <Article>
        <template #header>
            <h2>How to Request Military Medals</h2>
        </template>
        <template #content>
            <div id="post-212" class="clearfix post-212 page type-page status-publish hentry">
                <p>
                    <span style="text-decoration:underline">
                        The first thing you must do is be prepared to be disappointed.
                    </span>
                </p>
                <p>
                    Hundreds of thousands of military records were destroyed in a fire at the
                    National Personnel Records Center in the 1970's.&nbsp; Unfortunately, many of
                    these were records of WWII soldiers.&nbsp; But, as the old saying says, "Nothing
                    ventured, nothing gained."
                </p>
                <p>If you have access to a computer, you should visit this web site:</p>
                <p>
                    <a href="https://vetrecs.archives.gov/VeteranRequest/home.html">
                        https://vetrecs.archives.gov/VeteranRequest/home.html
                    </a>
                </p>
                <p>
                    You will be led through&nbsp;a series of steps to complete your request.&nbsp;
                    Near the end will be a remarks section where you can ask for any special items
                    such as replacement medals.&nbsp; These will be furnished only to the Veteran,
                    his parents, spouse, children or siblings. If you do not fall in one of these
                    categories, you will not be furnished replacements, but you can purchase them
                    online.&nbsp; In the last step, you will print off a simple document which you
                    will sign and send to the NPRC which simply confirms that you are the requester.
                </p>
                <p>
                    If you do not have access to a computer, you must complete a Standard Form 180
                    and mail it in.&nbsp; You may print a copy at this web site:
                </p>
                <p>
                    <a
                        href="http://www.archives.gov/research/order/standard-form-180.pdf?alt=media"
                    >
                        http://www.archives.gov/research/order/standard-form-180.pdf?alt=media
                    </a>
                </p>
                <p>
                    If you simply want replacement medals, and are qualified to receive them, write
                    a letter requesting that the soldier's separation documents be updated for
                    current awards, and replacement medals be provided. The document to enclose may
                    be either the DD Form 214 for relatively recent service, or WD AGO Form 35-53
                    for soldiers discharged in the 1940's. The officials at NPRC will send you
                    updated documents, and send the information on to US Army TACOM in Philadelphia,
                    PA, and that office will issue the replacement medals.
                </p>
                <p>
                    If you are unable to locate a DD Form 214 or WD AGO Form 35-53, you might try
                    writing a letter to the nearest VA Hospital and ask for copies of his VA
                    records.&nbsp; In your letter, begin the request with the phrase "Under the
                    Authority of the Freedom of Information Act, I request…"
                </p>
                <p>
                    You might also contact the county clerk where the soldier lived when he was
                    discharged.&nbsp; Soldiers were encouraged to file a copy of the separation
                    document with the County Clerk.
                </p>
                <p>
                    If your veteran was a member of the VFW, American Legion, or other veteran's
                    organizations, check with the group where your veteran was a member.&nbsp; Often
                    times they will require a copy of the separation papers for verification of
                    eligibility, and will keep it on file.
                </p>
                <p>
                    For personalized assistance, you might also check the local county clerks
                    office.&nbsp; Often there is a volunteer Veteran's Assistance Officer
                    available.&nbsp; Community Colleges also often have a Veteran's Assistance
                    Officer available.&nbsp; When you visit them, take all available information
                    with you.&nbsp; At a minimum, you should have the veteran's full name, branch of
                    service, and serial number.
                </p>
                <p>
                    <strong>All the above assumes your veteran is or was in the Army.</strong>
                    &nbsp; If using a computer at the E-VetRecs site, your request will be forwarded
                    to the appropriate site.&nbsp; If using the Standard Form 180, the last page
                    contains a listing of the other services (including Army Air Corps) and the
                    addresses to send the information to.&nbsp; Send your request (for Army
                    Personnel) to: National Personnel Records Center, Military Personnel Records, 1
                    Archives Drive, St Louis, MO 63138-1002
                </p>
                <p>-Hansel Haycox, Historian — Merrill's Marauders Proud Descendants</p>
            </div>
        </template>
    </Article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Article from '@/components/Article/Article.vue';

export default defineComponent({
    name: 'HowToRequestMilitaryMedals',
    components: { Article }
});
</script>
